//  @flow

import * as React from 'react';
import { withTranslation } from 'react-i18next';

import ImageBlurFallback from '../ImageBlurFallback';

import './style.css';

type IncrementCardProps = {
  image: string,
  title: string,
  toValue: number
};
type IncrementCardState = {
  currentVal: number
};

class IncrementCard extends React.PureComponent<
  IncrementCardProps,
  IncrementCardState
> {
  timeout: any;

  constructor(props: IncrementCardProps) {
    super(props);
    const { toValue } = this.props;
    this.state = {
      currentVal: toValue > 1000 ? Math.floor(toValue * 0.8) : 0
    };

    this.timeout = '';
  }

  componentDidMount = () => {
    this.startCounter();
  };

  startCounter = () => {
    this.timeout = setInterval(() => {
      this.setState((prevState): IncrementCardState => {
        if (prevState.currentVal === this.props.toValue) {
          clearInterval(this.timeout);
          return {};
        }

        return { currentVal: prevState.currentVal + 1 };
      });
    }, 10);
  };

  render() {
    const { t, className, webpImage, image, fallbackImage = '' } = this.props;
    return (
      <div className={`incement-card ${className}`}>
        <ImageBlurFallback
          fallbackImage={fallbackImage}
          className="incement-card-img"
          webpImage={webpImage}
          src={image}
          alt={t('incrementcardImgAlt')}
        />
        <p>{this.state.currentVal}+</p>
        <span>{this.props.title}</span>
      </div>
    );
  }
}

export default withTranslation()(IncrementCard);



// WEBPACK FOOTER //
// ./src/Components/IncrementCard/index.js